import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import { RadioGroupItem } from '@radix-ui/react-radio-group';
import { type JSX, useRef } from 'react';
import { useHover } from 'usehooks-ts';
type Size = 'compact' | 'default';
type ContentProps = {
  title: string | JSX.Element;
  description?: string;
  IconComponent: Icon;
  selected: boolean;
  disabled?: boolean;
  size?: Size;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  value: string;
};
const Content = t0 => {
  const $ = _c(29);
  const {
    size: t1,
    selected,
    disabled,
    IconComponent,
    title,
    description,
    onClick,
    value
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  const ref = useRef(null);
  const isHovered = useHover(ref as React.RefObject<HTMLElement>);
  const t2 = typeof title === "string" ? title : "option";
  const t3 = !!disabled;
  let t4;
  if ($[0] !== IconComponent) {
    t4 = <IconComponent />;
    $[0] = IconComponent;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== isHovered || $[3] !== selected || $[4] !== size || $[5] !== t3 || $[6] !== t4) {
    t5 = <div className="fp-radio-select-icon" data-selected={selected} data-disabled={t3} data-size={size} data-hovered={isHovered}>{t4}</div>;
    $[2] = isHovered;
    $[3] = selected;
    $[4] = size;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = !!disabled;
  let t7;
  if ($[8] !== isHovered || $[9] !== selected || $[10] !== t6 || $[11] !== title) {
    t7 = <div className="fp-radio-select-title text-label-2" data-selected={selected} data-disabled={t6} data-hovered={isHovered}>{title}</div>;
    $[8] = isHovered;
    $[9] = selected;
    $[10] = t6;
    $[11] = title;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== description || $[14] !== disabled || $[15] !== size) {
    t8 = size === "default" && <div className="fp-radio-select-description text-body-2" data-disabled={!!disabled}>{description}</div>;
    $[13] = description;
    $[14] = disabled;
    $[15] = size;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <div className="flex flex-col items-start">{t7}{t8}</div>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== disabled || $[21] !== onClick || $[22] !== selected || $[23] !== size || $[24] !== t2 || $[25] !== t5 || $[26] !== t9 || $[27] !== value) {
    t10 = <RadioGroupItem aria-label={t2} aria-selected={selected} className="fp-radio-select-option" disabled={disabled} onClick={onClick} type="button" value={value} ref={ref} data-selected={selected} data-size={size}>{t5}{t9}</RadioGroupItem>;
    $[20] = disabled;
    $[21] = onClick;
    $[22] = selected;
    $[23] = size;
    $[24] = t2;
    $[25] = t5;
    $[26] = t9;
    $[27] = value;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};
export default Content;